import React from 'react';
import { Route, Routes } from 'react-router-dom';
import history from './router/history';
import routes, { routesTemplate } from './router/routes';
import { getBaseAppPath } from './constants/baseAppPath';
import HistoryRouter from './components/HistoryRouter';

const BackButtonTemplate = React.lazy(() =>
  import('./templates/BackButtonTemplate/BackButtonTemplate')
);

const HomePage = React.lazy(() => import('./pages/HomePage/HomePage'));
const DetailPromotionPage = React.lazy(() =>
  import('./pages/DetailPromotionPage/DetailPromotionPage')
);
const DashboardPage = React.lazy(() => import('./pages/DashboardPage/DashboardPage'));

const NotFoundPage = React.lazy(() => import('./pages/NotFoundPage'));

function App() {
  const baseAppPath = getBaseAppPath();
  return (
    <HistoryRouter
      history={history}
      basename={baseAppPath}
    >
      <Routes>
        <Route
          path={routes.home.exactPathname}
          element={<HomePage />}
        />
        <Route
          path={routesTemplate.backButtonTemplate.exactPathname}
          element={<BackButtonTemplate />}
        >
          <Route
            path={routes.detailPromotion.exactPathname}
            element={<DetailPromotionPage />}
          />
        </Route>
        <Route
          path={routes.dashboard.exactPathname}
          element={<DashboardPage />}
        />
        <Route
          path={routes.notFound.exactPathname}
          element={<NotFoundPage />}
        />
      </Routes>
    </HistoryRouter>
  );
}

export default App;
